// import React, { useState, useEffect } from "react";
// const AboutSection = () => {
//   const [aboutData, setAboutData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Fetch about data from API
//   useEffect(() => {
//     const fetchAboutData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/about-section");

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();

//         if (result.success) {
//           setAboutData(result.data);
//         } else {
//           setApiError(result.message || "Failed to fetch about data");
//         }
//       } catch (err) {
//         console.error("Error fetching about data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAboutData();
//   }, []);

//   // Loading state
//   if (isLoading) {
//     return (
//       <div className="text-center py-5">

//       </div>
//     );
//   }

//   // Error state
//   if (apiError) {
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading About Section</h4>
//         <p>{apiError}</p>
//         <button
//           className="btn btn-outline-danger"
//           onClick={() => window.location.reload()}
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   // If no about data or section is inactive, don't render anything
//   if (!aboutData || !aboutData.isActive) {
//     return null;
//   }

//   // Render a single about section
//   const renderAboutSection = (section, reverseLayout = false) => {
//     if (!section || !section.isActive) return null;

//     return (





//       // <><section className="inner_feature-area pt-140 pb-140" id="about-sec">
//       //   <div className="container">
//       //     <div className="row align-items-center">
//       //       <div className="col-xl-5 col-lg-5 col-md-6">
//       //         <div className="inner_feature-content mb-50 mb-md-0">
//       //           <div className="inner_section-area mb-20">
//       //             <span className="inner_section-subtitle tp_subtitle_anim">{section.subtitle || "What We Do"}</span>
//       //             <h2 className="inner_section-title tp_title_slideup mb-30">
//       //               {section.title || "Create your own AI business easily."}</h2>
//       //             <p className="inner_section-text tp_fade_bottom">{section.description}</p>
//       //           </div>
//       //           {section.features && section.features.length > 0 && (
//       //             <ul className="inner_feature-content-list tp_fade_bottom">
//       //               {section.features.map((feature, index) => (
//       //                 <li key={index}>
//       //                   <i className="bx bx-check" /> {feature.text}
//       //                 </li>
//       //               ))}
//       //             </ul>
//       //           )}

//       //           <a href={section.buttonLink || "#"} className="theme-btn-2 tp_fade_bottom">{section.buttonText}</a>
//       //         </div>
//       //       </div>
//       //       <div className="col-xl-7 col-lg-7 col-md-6">
//       //         <div className="inner_feature-img tp_fade_left">
//       //           {section.images && section.images.length > 0 ? (
//       //             <img
//       //               src={section.images[0].url}
//       //               alt={section.images[0].alt || "Feature image"}
//       //               onError={(e) => {
//       //                 e.target.onerror = null;
//       //                 e.target.src = "https://placehold.co/600x400?text=Feature+Image";
//       //               }}
//       //             />
//       //           ) : (
//       //             <img
//       //               src="https://placehold.co/600x400?text=Feature+Image"
//       //               alt="Placeholder image"
//       //             />
//       //           )}
//       //         </div>

//       //       </div>
//       //     </div>
//       //   </div>
//       // </section>
//       // </>

//       <> <section className="gt-about-section fix section-padding pt-0">
//   <div className="container">
//     <div className="gt-about-wrapper-3 section-padding pb-0">
//       <div className="clicp-shape">
//         <img src="assets/img/new-add/clip-path.png" alt="img" />
//       </div>
//       <div className="row g-4">
//         <div className="col-xl-6">
//           <div className="gt-about-content">
//             <div className="gt-section-title style-3 mb-0">
//               <h6 className="tt-capitalize wow fadeInUp">Why boostly crm</h6>
//               <h2 className="char-animation">
//                 Deliver unforgettable
//                 customer&nbsp;experiences
//               </h2>
//             </div>
//             <p className="gt-text wow fadeInUp" data-wow-delay=".3s">
//               There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage
//             </p>
//             <ul className="gt-list-items wow fadeInUp" data-wow-delay=".5s">
//               <li>
//                 <span className="gt-circle-box" />
//                 <div className="gt-content">
//                   <h4>All-in-One CRM</h4>
//                   <span>
//                     Automate your sales, marketing, and service in one platform. Avoid data leaks and enable consistent messaging.
//                   </span>
//                 </div>
//               </li>
//               <li>
//                 <span className="gt-circle-box" />
//                 <div className="gt-content">
//                   <h4>Affordable</h4>
//                   <span>
//                     Make the most of Agile's modern features &amp; integrations, easy implementation and great support at an affordable price.
//                   </span>
//                 </div>
//               </li>
//               <li>
//                 <span className="gt-circle-box" />
//                 <div className="gt-content">
//                   <h4>Next-Generation</h4>
//                   <span>
//                     Automate your sales, marketing, and service in one platform. Avoid data leaks and enable consistent messaging.
//                   </span>
//                 </div>
//               </li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-6">
//           <div className="gt-about-image agn-choose-5-img">
//             <div className="crm-imagewow wow fadeInRight" data-wow-delay=".3s">
//               <img src="assets/img/new-add/crm-img.png" alt />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>
// </>
//     );
//   };

//   return (
//     <>
//       {/* First Section - Original Layout (Image Left, Content Right) */}
//       {renderAboutSection(aboutData.section1)}

//       {/* Second Section - Reversed Layout (Content Left, Image Right) */}
//       {/* {renderAboutSection(aboutData.section2, true)} */}
//     </>
//   );
// };

// export default AboutSection;


// import React, { useState, useEffect } from "react";

// const AboutSection = () => {
//   const [aboutData, setAboutData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   // Fetch about data from API
//   useEffect(() => {
//     const fetchAboutData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/about-section");

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();

//         if (result.success) {
//           setAboutData(result.data);
//         } else {
//           setApiError(result.message || "Failed to fetch about data");
//         }
//       } catch (err) {
//         console.error("Error fetching about data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAboutData();
//   }, []);

//   // Loading state
//   if (isLoading) {
//     return <div className="text-center py-5"></div>;
//   }

//   // Error state
//   if (apiError) {
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading About Section</h4>
//         <p>{apiError}</p>
//         <button
//           className="btn btn-outline-danger"
//           onClick={() => window.location.reload()}
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   // If no about data or section is inactive, don't render anything
//   if (!aboutData || !aboutData.isActive) {
//     return null;
//   }

//   // Dynamic section renderer (keeps your original UI)
//   const renderAboutSection = (section) => {
//     if (!section || !section.isActive) return null;

//     return (
//       // <>
//       //   <section className="gt-about-section fix section-padding pt-0" id="about-sec">
//       //     <div className="container">
//       //       <div className="gt-about-wrapper-3 section-padding pb-0">
//       //         <div className="clicp-shape">
//       //           <img
//       //             src={
//       //               section.clipShape ||
//       //               "assets/img/new-add/clip-path.png"
//       //             }
//       //             alt="shape"
//       //           />
//       //         </div>
//       //         <div className="row g-4">
//       //           {/* LEFT CONTENT */}
//       //           <div className="col-xl-6">
//       //             <div className="gt-about-content">
//       //               <div className="gt-section-title style-3 mb-0">
//       //                 <h6 className="tt-capitalize wow fadeInUp">
//       //                   {section.subtitle || "Why boostly crm"}
//       //                 </h6>
//       //                 <h2 className="char-animation">
//       //                   {section.title ||
//       //                     "Deliver unforgettable customer experiences"}
//       //                 </h2>
//       //               </div>
//       //               <p
//       //                 className="gt-text wow fadeInUp"
//       //                 data-wow-delay=".3s"
//       //               >
//       //                 {section.description ||
//       //                   "There are many variations of passages of Lorem Ipsum available..."}
//       //               </p>

//       //               {/* FEATURES LIST */}
//       //               {section.features && section.features.length > 0 && (
//       //                 <ul
//       //                   className="gt-list-items wow fadeInUp"
//       //                   data-wow-delay=".5s"
//       //                 >
//       //                   {section.features.map((feature, index) => (
//       //                     <li key={index}>
//       //                       <span className="gt-circle-box" />
//       //                       <div className="gt-content">
//       //                         <h4>{feature.title}</h4>
//       //                         <span>{feature.text}</span>
//       //                       </div>
//       //                     </li>
//       //                   ))}
//       //                 </ul>
//       //               )}
//       //             </div>
//       //           </div>

//       //           {/* RIGHT IMAGE */}
//       //           <div className="col-xl-6">
//       //             <div className="gt-about-image agn-choose-5-img">
//       //               <div
//       //                 className="crm-imagewow wow fadeInRight"
//       //                 data-wow-delay=".3s"
//       //               >
//       //                 <img
//       //                   src={
//       //                     (section.images && section.images[0]?.url) ||
//       //                     "assets/img/new-add/crm-img.png"
//       //                   }
//       //                   alt={
//       //                     (section.images && section.images[0]?.alt) ||
//       //                     "about image"
//       //                   }
//       //                   onError={(e) => {
//       //                     e.target.onerror = null;
//       //                     e.target.src =
//       //                       "https://placehold.co/600x400?text=About+Image";
//       //                   }}
//       //                 />
//       //               </div>
//       //             </div>
//       //           </div>
//       //         </div>
//       //       </div>
//       //     </div>
//       //   </section>
//       // </>

//       <> <section id="about-sec" className="ww-do-area pt-100 pb-130 rel z-1">
//   <div className="container">
//     <div className="row justify-content-between align-items-center">
//       <div className="col-xl-5 col-lg-6">
//         <div className="ww-do-content rmb-65">
//           <div className="section-title mb-40 wow fadeInRight delay-0-2s">
//             <span className="sub-title style-two mb-15">What We Do</span>
//             <h2>We Create Your Unique Online Websites</h2>

//             <p>Sit amet consectetur adipiscing sed eiusmod tempor incididunt labore et dolore magnaes epsums Sit amet consectetur adipiscing sed eiusmod tempor incididunt labore et dolore magnaes epsums</p>
//           </div>
//           <div className="feature-three-wrap">
//             <div className="feature-item-three wow fadeInRight delay-0-3s">
//               <i className="flaticon-technical-support" />
//               <div className="content">
//                 <h4>Customize your site</h4>

//               </div>
//             </div>
//             <div className="feature-item-three color-two wow fadeInRight delay-0-4s">
//               <i className="flaticon-settings" />
//               <div className="content">
//                 <h4>Add advanced features</h4>

//               </div>
//             </div>
//             <div className="feature-item-three color-three wow fadeInRight delay-0-5s">
//               <i className="flaticon-app-development" />
//               <div className="content">
//                 <h4>Edit your mobile view</h4>

//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//       <div className="col-lg-6">
//         <div className="ww-do-images">
//           <img className="image-one wow fadeInDown delay-0-2s" src="assets/images/about/ww-do1.png" alt="What We Do" />


//         </div>
//       </div>
//     </div>
//   </div>
// </section>
// </>
//     );
//   };

//   return (
//     <>
//       {/* Dynamic About Section */}
//       {renderAboutSection(aboutData.section1)}
//     </>
//   );
// };

// export default AboutSection;

// import React, { useState, useEffect } from "react";

// const AboutSection = () => {
//   const [aboutData, setAboutData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   useEffect(() => {
//     const fetchAboutData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/about-section");
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//         const result = await response.json();

//         if (result.success) setAboutData(result.data);
//         else setApiError(result.message || "Failed to fetch about data");
//       } catch (err) {
//         console.error("Error fetching about data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAboutData();
//   }, []);

//   if (isLoading) return <div className="text-center py-5">Loading...</div>;

//   if (apiError)
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading About Section</h4>
//         <p>{apiError}</p>
//         <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
//           Retry
//         </button>
//       </div>
//     );

//   if (!aboutData || !aboutData.isActive) return null;

//   const section = aboutData.section1 || aboutData;

//   return (
//     // <section id="why-choose" className="why-choose-area py-120 rpb-130 rel z-1 overflow-hidden">
//     //   <div className="container">
//     //     <div className="row justify-content-between align-items-center">
//     //       {/* LEFT CONTENT */}
//     //       <div className="col-xl-5 col-lg-6">
//     //         <div className="why-choose-content pt-10 rmb-65 wow fadeInUp delay-0-2s">
//     //           <div className="section-title mb-35">
//     //             <span className="sub-title mb-15">{section.subtitle || "Why Choose Us"}</span>
//     //             <h2>{section.title || "Web design company that you can trust"}</h2>

//     //              <p>
//     //               {section.description ||
//     //                 "Sit amet consectetur adipiscing sed eiusmod tempor incididunt labore et dolore magnaes epsums Sit amet consectetur adipiscing sed eiusmod tempor incididunt labore et dolore magnaes epsums"}
//     //             </p>
//     //           </div>
//     //           <ul className="list-style-one">
//     //             {section.features && section.features.length > 0 ? (
//     //               section.features.map((feature, idx) => (
//     //                 <li key={idx}>
//     //                   <div className="content">
//     //                     <h5>{feature.text}</h5>
//     //                   </div>
//     //                 </li>
//     //               ))
//     //             ) : (
//     //               <>
//     //                 <li>
//     //                   <div className="content">
//     //                     <h5>Competitive rates</h5>
//     //                   </div>
//     //                 </li>
//     //                 <li>
//     //                   <div className="content">
//     //                     <h5>Premium Development</h5>
//     //                   </div>
//     //                 </li>
//     //                 <li>
//     //                   <div className="content">
//     //                     <h5>Retina Ready &amp; Super Flexible</h5>
//     //                   </div>
//     //                 </li>
//     //                 <li>
//     //                   <div className="content">
//     //                     <h5>No contracts needed</h5>
//     //                   </div>
//     //                 </li>
//     //               </>
//     //             )}
//     //           </ul>
//     //         </div>
//     //       </div>

//     //       {/* RIGHT IMAGE */}
//     //       <div className="col-lg-6">
//     //         <div className="why-choose-image wow fadeInUp delay-0-4s">
//     //           <img
//     //             src={
//     //               (section.images && section.images[0]?.url) ||
//     //               "assets/images/about/why-choose-us.png"
//     //             }
//     //             alt={(section.images && section.images[0]?.alt) || "why choose us"}
//     //             onError={(e) => {
//     //               e.target.onerror = null;
//     //               e.target.src = "https://placehold.co/600x400?text=About+Image";
//     //             }}
//     //           />
//     //         </div>
//     //       </div>
//     //     </div>
//     //   </div>

//     //   {/* Decorative shapes */}
//     //   <div className="circle-shapes">
//     //     <span className="shape one wow slideInDown delay-0-2s" />
//     //     <span className="shape two wow slideInDown delay-0-4s" />
//     //     <span className="shape three wow slideInDown delay-0-6s" />
//     //     <span className="shape four wow slideInDown delay-0-8s" />
//     //   </div>
//     // </section>

// //     <> <section>
// //   <div className="cs_height_140 cs_height_lg_80" />
// //   <div className="container">
// //     <div className="cs_card cs_style_1 cs_type_6">
// //       <div className="row cs_gap_y_40">
// //         <div className="col-xl-6 col-lg-6">
// //           <div className="cs_card_thumbnail cs_center position-relative wow fadeInLeft">
// //             <img src="assets/img/feature_9.png" alt="Man image" />
// //             <div className="cs_thumbnail_before cs_radius_100 position-absolute">
// //             </div>
// //             <div className="cs_illustration_1 cs_radius_20 position-absolute">
// //               <img src="assets/img/Illustration_5.png" alt="Analytics chart image" />
// //             </div>
// //             <div className="cs_illustration_2 cs_radius_20 position-absolute">
// //               <img src="assets/img/Illustration_6.png" alt="User info image" />
// //             </div>
// //           </div>
// //         </div>
// //         <div className="col-xl-5 col-lg-6 offset-xl-1">
// //           <div className="cs_section_heading cs_style_1 cs_mb_40">
// //             <h2 className="cs_section_title cs_fs_50 cs_mb_19 wow fadeInDown">Upgrade Your Business with Our CRM Solution</h2>
// //             <hr />
// //           </div>
// //           <div className="cs_iconbox_wrapper position-relative z-2">
// //             <div className="cs_iconbox cs_style_6 cs_mb_36 wow fadeInLeft">
// //               <span className="cs_iconbox_icon cs_center cs_purple_bg cs_white_color cs_radius_100">
// //                 <img src="assets/img/icons/magnet-user.svg" alt="User icon" />                   
// //               </span>
// //               <div className="cs_iconbox_info">
// //                 <h3 className="cs_fs_29 cs_normal">High-Quality Leads</h3>
// //                 <p className="mb-0">Discover how to use AI-powered marketing tools to attract and convert more leads without multiplying your marketing spend.</p>
// //               </div>
// //             </div>
// //             <div className="cs_iconbox cs_style_6 cs_mb_36 wow fadeInLeft" data-wow-delay="200ms">
// //               <span className="cs_iconbox_icon cs_center cs_purple_bg cs_white_color cs_radius_100">
// //                 <img src="assets/img/icons/rocket-lunch.svg" alt="Rocket icon" />
// //               </span>
// //               <div className="cs_iconbox_info">
// //                 <h3 className="cs_fs_29 cs_normal">Accelerate Sales</h3>
// //                 <p className="mb-0">Start closing more deals faster and streamlining your sales process with HubSpot’s AI-powered deal management tools.</p>
// //               </div>
// //             </div>
// //             <div className="cs_iconbox cs_style_6 wow fadeInLeft" data-wow-delay="400ms">
// //               <span className="cs_iconbox_icon cs_center cs_purple_bg cs_white_color cs_radius_100">
// //                 <img src="assets/img/icons/journey.svg" alt="Journey icon" />                     
// //               </span>
// //               <div className="cs_iconbox_info">
// //                 <h3 className="cs_fs_29 cs_normal">Create Customer Journey</h3>
// //                 <p className="mb-0">Fuel the entire customer journey with content across formats and channels with all-in-one, AI-powered content marketing software.</p>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   </div>
// //   <div className="cs_height_140 cs_height_lg_80" />
// // </section>
// // </>

// <><section>
//   <div className="cs_height_130 cs_height_lg_80" />
//   <div className="container">
  
//     <div className="cs_height_130 cs_height_lg_80" />
//     <div className="cs_card cs_style_1">
//       <div className="row cs_gap_y_40 align-items-center">
//         <div className="col-xl-5 col-lg-5 offset-xl-1 order-lg-2">
//           <div className="cs_card_thumbnail cs_radius_15 position-relative wow fadeInRight">
//             <img src="assets/img/feature_2.jpg" alt="Feature image" />
//             <div className="cs_illustration position-absolute">
//               <img src="assets/img/Illustration.png" alt="Analytics chart image" />
//             </div>
//           </div>
//         </div>
//         <div className="col-xl-6 col-lg-7 order-lg-1">
//           <div className="cs_card_content">
//             <div className="cs_section_heading cs_style_1 cs_mb_30">
//               <h5 className="">What we Do</h5>
//               <h2 className="cs_section_title cs_fs_50 cs_mb_27 wow fadeInDown">Convert your data into meaningful insights</h2>
//               <p className="cs_section_text cs_fs_21 mb-0">Gain precise insights for your business with our advanced analytics tools. Make informed decisions based on accurate, real-time data.</p>
//             </div>
//             <ul className="cs_list cs_style_1 cs_mp_0 wow fadeInLeft">
//               <li>
//                 <span className="cs_list_icon cs_accent_color">
//                   <svg width={30} height={30} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <g clipPath="url(#clip0_1573_69745)">
//                       <path d="M27.803 6.59L23.4093 2.19625C21.9918 0.78 20.108 0 18.1055 0H11.8918C9.8893 0 8.00555 0.78 6.58805 2.19625L2.1943 6.59C0.778047 8.0075 -0.00195312 9.89125 -0.00195312 11.8938V18.1075C-0.00195312 20.11 0.778047 21.9937 2.1943 23.4113L6.58805 27.805C8.00555 29.2212 9.8893 30.0012 11.8918 30.0012H18.1055C20.108 30.0012 21.9918 29.2212 23.4093 27.805L27.803 23.4113C29.2193 21.9937 29.9993 20.11 29.9993 18.1075V11.8938C29.9993 9.89125 29.2193 8.0075 27.803 6.59ZM22.9155 12.2913L16.3755 18.8312C15.6093 19.5975 14.5905 20.02 13.5068 20.02C12.423 20.02 11.4043 19.5975 10.638 18.8312L7.1543 15.3475C6.66555 14.8587 6.66555 14.0688 7.1543 13.58C7.64305 13.0913 8.43305 13.0913 8.9218 13.58L12.4055 17.0637C12.9943 17.6525 14.0205 17.6513 14.608 17.0637L21.148 10.5237C21.6368 10.035 22.4268 10.035 22.9155 10.5237C23.4043 11.0125 23.4043 11.8025 22.9155 12.2913Z" fill="currentColor" />
//                     </g>
//                     <defs>
//                       <clipPath id="clip0_1573_69746">
//                         <rect width={30} height={30} fill="white" />
//                       </clipPath>
//                     </defs>
//                   </svg>
//                 </span>
//                 <span className="cs_fs_21 cs_heading_color">Actionable Insights</span>
//               </li>
//               <li>
//                 <span className="cs_list_icon cs_accent_color">
//                   <svg width={30} height={30} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <g clipPath="url(#clip0_1573_697457)">
//                       <path d="M27.803 6.59L23.4093 2.19625C21.9918 0.78 20.108 0 18.1055 0H11.8918C9.8893 0 8.00555 0.78 6.58805 2.19625L2.1943 6.59C0.778047 8.0075 -0.00195312 9.89125 -0.00195312 11.8938V18.1075C-0.00195312 20.11 0.778047 21.9937 2.1943 23.4113L6.58805 27.805C8.00555 29.2212 9.8893 30.0012 11.8918 30.0012H18.1055C20.108 30.0012 21.9918 29.2212 23.4093 27.805L27.803 23.4113C29.2193 21.9937 29.9993 20.11 29.9993 18.1075V11.8938C29.9993 9.89125 29.2193 8.0075 27.803 6.59ZM22.9155 12.2913L16.3755 18.8312C15.6093 19.5975 14.5905 20.02 13.5068 20.02C12.423 20.02 11.4043 19.5975 10.638 18.8312L7.1543 15.3475C6.66555 14.8587 6.66555 14.0688 7.1543 13.58C7.64305 13.0913 8.43305 13.0913 8.9218 13.58L12.4055 17.0637C12.9943 17.6525 14.0205 17.6513 14.608 17.0637L21.148 10.5237C21.6368 10.035 22.4268 10.035 22.9155 10.5237C23.4043 11.0125 23.4043 11.8025 22.9155 12.2913Z" fill="currentColor" />
//                     </g>
//                     <defs>
//                       <clipPath id="clip0_1573_69748">
//                         <rect width={30} height={30} fill="white" />
//                       </clipPath>
//                     </defs>
//                   </svg>
//                 </span>
//                 <span className="cs_fs_21 cs_heading_color">Enhanced Decision-Making</span>
//               </li>
//               <li>
//                 <span className="cs_list_icon cs_accent_color">
//                   <svg width={30} height={30} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <g clipPath="url(#clip0_1573_697468)">
//                       <path d="M27.803 6.59L23.4093 2.19625C21.9918 0.78 20.108 0 18.1055 0H11.8918C9.8893 0 8.00555 0.78 6.58805 2.19625L2.1943 6.59C0.778047 8.0075 -0.00195312 9.89125 -0.00195312 11.8938V18.1075C-0.00195312 20.11 0.778047 21.9937 2.1943 23.4113L6.58805 27.805C8.00555 29.2212 9.8893 30.0012 11.8918 30.0012H18.1055C20.108 30.0012 21.9918 29.2212 23.4093 27.805L27.803 23.4113C29.2193 21.9937 29.9993 20.11 29.9993 18.1075V11.8938C29.9993 9.89125 29.2193 8.0075 27.803 6.59ZM22.9155 12.2913L16.3755 18.8312C15.6093 19.5975 14.5905 20.02 13.5068 20.02C12.423 20.02 11.4043 19.5975 10.638 18.8312L7.1543 15.3475C6.66555 14.8587 6.66555 14.0688 7.1543 13.58C7.64305 13.0913 8.43305 13.0913 8.9218 13.58L12.4055 17.0637C12.9943 17.6525 14.0205 17.6513 14.608 17.0637L21.148 10.5237C21.6368 10.035 22.4268 10.035 22.9155 10.5237C23.4043 11.0125 23.4043 11.8025 22.9155 12.2913Z" fill="currentColor" />
//                     </g>
//                     <defs>
//                       <clipPath id="clip0_1573_697410">
//                         <rect width={30} height={30} fill="white" />
//                       </clipPath>
//                     </defs>
//                   </svg>
//                 </span>
//                 <span className="cs_fs_21 cs_heading_color">Improved Efficiency</span>
//               </li>
//             </ul>
//             <a href="register.html" aria-label="Sign up button" className="cs_btn cs_style_1 cs_purple_bg cs_white_color cs_semibold wow fadeInUp">
//               <span>Get Started Now</span>
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   <div className="cs_height_130 cs_height_lg_80" />
// </section>
// </>
//   );
// };

// export default AboutSection;


// import React, { useState, useEffect } from "react";

// const AboutSection = () => {
//   const [aboutData, setAboutData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [apiError, setApiError] = useState(null);

//   useEffect(() => {
//     const fetchAboutData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/about-section");
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//         const result = await response.json();

//         if (result.success) setAboutData(result.data);
//         else setApiError(result.message || "Failed to fetch about data");
//       } catch (err) {
//         console.error("Error fetching about data:", err);
//         setApiError("Network error or server not responding");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAboutData();
//   }, []);

//   if (isLoading) return <div className="text-center py-5">Loading...</div>;
//   if (apiError)
//     return (
//       <div className="alert alert-danger text-center py-5" role="alert">
//         <h4>Error Loading About Section</h4>
//         <p>{apiError}</p>
//         <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
//           Retry
//         </button>
//       </div>
//     );

//   if (!aboutData || !aboutData.isActive) return null;

//   // Use dynamic fields safely
//   const section = aboutData.section1 || aboutData;
//   const {
//     subtitle = "What we Do",
//     title = "Convert your data into meaningful insights",
//     description = "Gain precise insights for your business with our advanced analytics tools. Make informed decisions based on accurate, real-time data.",
//     buttonText = "Get Started Now",
//     buttonLink = "/register",
//     image = "assets/img/feature_2.jpg",
//     illustration = "assets/img/Illustration.png",
//     features = [
//       { text: "Actionable Insights" },
//       { text: "Enhanced Decision-Making" },
//       { text: "Improved Efficiency" },
//     ],
//   } = section;

//   return (
//     <>
//       <section>
//         <div className="cs_height_130 cs_height_lg_80" />
//         <div className="container">
//           <div className="cs_height_130 cs_height_lg_80" />
//           <div className="cs_card cs_style_1">
//             <div className="row cs_gap_y_40 align-items-center">
//               {/* RIGHT IMAGE */}
//               <div className="col-xl-5 col-lg-5 offset-xl-1 order-lg-2">
//                 <div className="cs_card_thumbnail cs_radius_15 position-relative wow fadeInRight">
//                   <img
//                     src={image}
//                     alt={title}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = "https://placehold.co/600x400?text=About+Image";
//                     }}
//                   />
//                   <div className="cs_illustration position-absolute">
                    
                   
//                   </div>
//                 </div>
//               </div>

//               {/* LEFT CONTENT */}
//               <div className="col-xl-6 col-lg-7 order-lg-1">
//                 <div className="cs_card_content">
//                   <div className="cs_section_heading cs_style_1 cs_mb_30">
//                     <h5>{subtitle}</h5>
//                     <h2 className="cs_section_title cs_fs_50 cs_mb_27 wow fadeInDown">
//                       {title}
//                     </h2>
//                     <p className="cs_section_text cs_fs_21 mb-0">{description}</p>
//                   </div>

//                   {/* Dynamic Features */}
//                   <ul className="cs_list cs_style_1 cs_mp_0 wow fadeInLeft">
//                     {features.map((feature, idx) => (
//                       <li key={idx}>
//                         <span className="cs_list_icon cs_accent_color">
//                           <svg
//                             width={30}
//                             height={30}
//                             viewBox="0 0 30 30"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <g clipPath={`url(#clip0_${idx})`}>
//                               <path
//                                 d="M27.803 6.59L23.4093 2.19625C21.9918 0.78 20.108 0 18.1055 0H11.8918C9.8893 0 8.00555 0.78 6.58805 2.19625L2.1943 6.59C0.778047 8.0075 -0.00195312 9.89125 -0.00195312 11.8938V18.1075C-0.00195312 20.11 0.778047 21.9937 2.1943 23.4113L6.58805 27.805C8.00555 29.2212 9.8893 30.0012 11.8918 30.0012H18.1055C20.108 30.0012 21.9918 29.2212 23.4093 27.805L27.803 23.4113C29.2193 21.9937 29.9993 20.11 29.9993 18.1075V11.8938C29.9993 9.89125 29.2193 8.0075 27.803 6.59ZM22.9155 12.2913L16.3755 18.8312C15.6093 19.5975 14.5905 20.02 13.5068 20.02C12.423 20.02 11.4043 19.5975 10.638 18.8312L7.1543 15.3475C6.66555 14.8587 6.66555 14.0688 7.1543 13.58C7.64305 13.0913 8.43305 13.0913 8.9218 13.58L12.4055 17.0637C12.9943 17.6525 14.0205 17.6513 14.608 17.0637L21.148 10.5237C21.6368 10.035 22.4268 10.035 22.9155 10.5237C23.4043 11.0125 23.4043 11.8025 22.9155 12.2913Z"
//                                 fill="currentColor"
//                               />
//                             </g>
//                             <defs>
//                               <clipPath id={`clip0_${idx}`}>
//                                 <rect width={30} height={30} fill="white" />
//                               </clipPath>
//                             </defs>
//                           </svg>
//                         </span>
//                         <span className="cs_fs_21 cs_heading_color">{feature.text}</span>
//                       </li>
//                     ))}
//                   </ul>

//                   {/* Dynamic Button */}
//                   <a
//                     href={buttonLink}
//                     aria-label="Sign up button"
//                     className="cs_btn cs_style_1 cs_purple_bg cs_white_color cs_semibold wow fadeInUp"
//                   >
//                     <span>{buttonText}</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="cs_height_130 cs_height_lg_80" />
//       </section>
//     </>
//   );
// };

// export default AboutSection;


import React, { useState, useEffect } from "react";

const AboutSection = () => {
  const [aboutData, setAboutData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/api/about-section");
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();

        if (result.success) setAboutData(result.data);
        else setApiError(result.message || "Failed to fetch about data");
      } catch (err) {
        console.error("Error fetching about data:", err);
        setApiError("Network error or server not responding");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (isLoading) return <div className="text-center py-5">Loading...</div>;
  if (apiError)
    return (
      <div className="alert alert-danger text-center py-5" role="alert">
        <h4>Error Loading About Section</h4>
        <p>{apiError}</p>
        <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
          Retry
        </button>
      </div>
    );

  if (!aboutData || !aboutData.section1) return null;

  const section = aboutData.section1;

  // Dynamic fields with fallbacks
  const {
    subtitle = "What We Do",
    title = "Convert your data into meaningful insights",
    description = "Gain precise insights for your business with our advanced analytics tools.",
    buttonText = "Get Started Now",
    buttonLink = "/register",
    features = [
      { text: "Actionable Insights" },
      { text: "Enhanced Decision-Making" },
      { text: "Improved Efficiency" },
    ],
    images = [],
  } = section;

  // Pick first image dynamically
  const image = images.length > 0 ? images[0].url : "https://placehold.co/600x400?text=About+Image";
  const imageAlt = images.length > 0 ? images[0].alt : title;

  return (
    <section>
      <div className="cs_height_130 cs_height_lg_80" />
      <div className="container">
        <div className="cs_height_130 cs_height_lg_80" />
        <div className="cs_card cs_style_1">
          <div className="row cs_gap_y_40 align-items-center">
            {/* RIGHT IMAGE */}
            <div className="col-xl-5 col-lg-5 offset-xl-1 order-lg-2">
              <div className="cs_card_thumbnail cs_radius_15 position-relative wow fadeInRight">
                <img
                  src={image}
                  alt={imageAlt}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://placehold.co/600x400?text=About+Image";
                  }}
                />
                <div className="cs_illustration position-absolute"></div>
              </div>
            </div>

            {/* LEFT CONTENT */}
            <div className="col-xl-6 col-lg-7 order-lg-1">
              <div className="cs_card_content">
                <div className="cs_section_heading cs_style_1 cs_mb_30">
                  <h5>{subtitle}</h5>
                  <h2 className="cs_section_title cs_fs_50 cs_mb_27 wow fadeInDown">
                    {title}
                  </h2>
                  <p className="cs_section_text cs_fs_21 mb-0">{description}</p>
                </div>

                {/* Dynamic Features */}
                <ul className="cs_list cs_style_1 cs_mp_0 wow fadeInLeft">
                  {features.map((feature, idx) => (
                    <li key={idx}>
                      <span className="cs_list_icon cs_accent_color">
                        <svg
                          width={30}
                          height={30}
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath={`url(#clip0_${idx})`}>
                            <path
                              d="M27.803 6.59L23.4093 2.19625C21.9918 0.78 20.108 0 18.1055 0H11.8918C9.8893 0 8.00555 0.78 6.58805 2.19625L2.1943 6.59C0.778047 8.0075 -0.00195312 9.89125 -0.00195312 11.8938V18.1075C-0.00195312 20.11 0.778047 21.9937 2.1943 23.4113L6.58805 27.805C8.00555 29.2212 9.8893 30.0012 11.8918 30.0012H18.1055C20.108 30.0012 21.9918 29.2212 23.4093 27.805L27.803 23.4113C29.2193 21.9937 29.9993 20.11 29.9993 18.1075V11.8938C29.9993 9.89125 29.2193 8.0075 27.803 6.59ZM22.9155 12.2913L16.3755 18.8312C15.6093 19.5975 14.5905 20.02 13.5068 20.02C12.423 20.02 11.4043 19.5975 10.638 18.8312L7.1543 15.3475C6.66555 14.8587 6.66555 14.0688 7.1543 13.58C7.64305 13.0913 8.43305 13.0913 8.9218 13.58L12.4055 17.0637C12.9943 17.6525 14.0205 17.6513 14.608 17.0637L21.148 10.5237C21.6368 10.035 22.4268 10.035 22.9155 10.5237C23.4043 11.0125 23.4043 11.8025 22.9155 12.2913Z"
                              fill="currentColor"
                            />
                          </g>
                          <defs>
                            <clipPath id={`clip0_${idx}`}>
                              <rect width={30} height={30} fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="cs_fs_21 cs_heading_color">{feature.text}</span>
                    </li>
                  ))}
                </ul>

                {/* Dynamic Button */}
                <a
                  href={buttonLink}
                  aria-label="Sign up button"
                  className="cs_btn cs_style_1 cs_purple_bg cs_white_color cs_semibold wow fadeInUp"
                >
                  <span>{buttonText}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_height_130 cs_height_lg_80" />
    </section>
  );
};

export default AboutSection;





